import { connect } from 'react-redux';

import EntityMultiSaveDialog from '../components/entity/MultiSaveDialog';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';

export default connect(
  null,
  defaultMapDispatchToProps
)(EntityMultiSaveDialog);
